import { makeStyles } from '@rbx/ui';
import { topNavigationHeight, getXLCenterContentMediaQuery } from '../constants/layoutConstants';

const useAppLayoutMainContentStyles = makeStyles<{
  mainMaxWidth: number;
  hasLeftNav: boolean;
}>()((theme, { mainMaxWidth, hasLeftNav }) => ({
  container: {
    margin: '0 auto',
    flexGrow: 1,
    // only support heading + code elements as we only expected those to be anchored
    // add margin equal to (top nav header height + a margin) for scroll positions
    '& h1[id], h2[id], h3[id], h4[id], h5[id], h6[id], code[id]': {
      scrollMarginTop: `${topNavigationHeight + Number(theme.spacing(1).slice(0, -2))}px`,
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      '& *': {
        fontSize: 'inherit',
      },
    },
    overflowWrap: 'break-word',
  },
  contentWrapper: {
    margin: '0 auto',
    justifyContent: 'center',
    [getXLCenterContentMediaQuery(mainMaxWidth)]: {
      // rely on absolute positioning of AppLayoutMain to center content
      justifyContent: 'flex-start',
      margin: hasLeftNav ? 0 : '0 auto',
    },
  },
  content: {
    width: '100%',
    maxWidth: mainMaxWidth,
  },
}));

export default useAppLayoutMainContentStyles;
